import { PropertyExplorerValue as theme } from 'legacy/css-modules';
import { Button } from 'legacy/components/Button';
import { dollarsFormatter } from 'legacy/utils/formatters';

export default ({
  label,
  value,
  subtext,
  handleSelect,
  altText,
  displayAltText,
  buttonText,
  dataHcNames = {},
  hideButton
}) => {
  return (
    <div className={theme['avm-selection-item']}>
      <div data-hc-name={dataHcNames.label} className={theme['avm-label']}>
        {label}
      </div>
      {displayAltText ? (
        <div
          data-hc-name={dataHcNames.description}
          className={theme['avm-alttext']}
        >
          {altText}
        </div>
      ) : (
        <div>
          <div
            data-hc-name={dataHcNames.value}
            className={theme['avm-value--selector']}
          >
            {dollarsFormatter(value)}
          </div>
          <div
            data-hc-name={dataHcNames.description}
            className={theme['avm-subtext']}
          >
            {subtext}
          </div>
        </div>
      )}

      <div className={theme['avm-button-wrapper']}>
        <Button
          disabled={hideButton}
          dataHcName={dataHcNames.button}
          mini
          className={theme['avm-button']}
          onClick={handleSelect}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};
